import { getErrorDetails, isExceptionWithNgOriginalError, isExceptionWithOriginalError } from './get-error-details';
import { ILogContext, isLogContextWithException } from './log-context.interface';

function getPartialErrorFromContext(context: ILogContext): Partial<Error> | undefined {
  if (!isLogContextWithException(context)) {
    return undefined;
  }

  /**
   * Try to unwrap the errors.
   */
  let errorCandidate: NonNullable<unknown> = context.exception;
  if (isExceptionWithNgOriginalError(context.exception)) {
    errorCandidate = context.exception.ngOriginalError;
  } else if (isExceptionWithOriginalError(context.exception)) {
    errorCandidate = context.exception.originalError;
  }

  if (typeof errorCandidate !== 'object') {
    let unknownError: Partial<Error> | undefined;
    try {
      unknownError = {
        message: `${errorCandidate}`,
      };
    } catch (e) {
      unknownError = undefined;
    }
    return unknownError;
  } else if (errorCandidate === null) {
    return undefined;
  }

  return getErrorDetails(errorCandidate);
}

export function getErrorFromContext(context: ILogContext): Error {
  let partialError: Partial<Error> | undefined = getPartialErrorFromContext(context);
  const theError: Error = new Error();
  theError.name = partialError?.name ? partialError.name : 'UnknownError';
  theError.message = partialError?.message ? partialError.message : 'Unknown captured error';
  theError.stack = partialError?.stack;
  return theError;
}
